<template>
    <div>
        <date-picker
            v-bind="$attrs"
            v-on="$listeners"
            v-model="dateValue"
            @input="onChangeInput"
            input-class="input-date-style"
            :format="formated"
            :lang="lang"
            :placeholder="placeholder"
            :disabled-date="disableDate"
            :default-value="dateDefault"
        > 
        </date-picker>
    </div>
</template>

<script>
import dayjs from 'dayjs';

    export default {
        name: 'DateInput',
        inheritAttrs:false,
        props: {
            label: {
                type: String,
                require: true
            }, 
            disabled: Boolean,
            readonly: Boolean,
            placeholder: String,
            dateToDisabled: [Date, String],
            dayToDisabled: Number,
            stateToDisabled: String,
            formated: { type: String, default: 'YYYY-MM-DD' },
            lang: { type: String, default: 'fr-fr' },
            defaultDate: [String, Date],
            dateRangeToDisable: { type: Array, default: () => [] }
        },
        data () {
            return {
                dateDefault: null,
                dateValue: null
            }
        },
        created() {
            this.setDateDefault()
        },
        methods : {
            setDateDefault() {
                if (this.defaultDate) {
                    this.dateDefault = new Date(this.defaultDate)
                    this.dateValue = this.dateDefault
                } else {
                    if (this.dateToDisabled) {
                        this.dateDefault = new Date(this.dateToDisabled)
                    } else {
                        this.dateDefault = new Date()
                    }
                }
            },
            onChangeInput() {
                this.$emit("valueDate", this.dateValue)
            },
            disableDate(date) {
                let dateToDisable = this.dateToDisabled;
                let dayToDisable = this.dayToDisabled || 0
                let stateToDisable = this.stateToDisabled || 'after'
                
                if (this.dateRangeToDisable && this.dateRangeToDisable.length === 2) {
                    let [dateBefore, dateAfter] = this.dateRangeToDisable
                    return date < new Date(dateBefore) || date > new Date(dateAfter)
                }

                if (!dateToDisable || dateToDisable === null ) return null
                
                if(stateToDisable === 'before') {
                    return date <= dayjs(dateToDisable).add(-dayToDisable, "day")
                } else if (stateToDisable === "after") {
                    return date > dayjs(dateToDisable).add(dayToDisable, "day")
                }
            }
        },
        mounted() {
            this.setDateDefault()
        }
    }
</script>

<style>
    .input-date-style {
        display: inline-block;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
        height: 60px;
        padding: 6px 30px;
        padding-left: 10px;
        font-size: 15px;
        line-height: 1.4;
        color: #555;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 15px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    }

    .input-date-style::placeholder {
        font-size: 15px;
    }

    .input-date-style:focus {
        outline-color: #ffa409;
    }

    .mx-datepicker {
        width: 100% !important;
    }
</style>
